import React, { useState, useEffect } from 'react';

import './EditableLink.css'

import sanitizeInput from '../../../helpers/sanitizeInput';

// for testing only. remove later
import load_spell from '../../Spell/helpers/load_spell.js'

// ----------------------------------------------------------------------------------
//                         Description
//
//     EditableLink is a text input field that can be locked to become a hyperlink instead
//
//     <EditableLink initial="Fireball" link="spells(Fireball)" id="mysp31" />
//
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function EditableLink(props) {

    // ------------ parameters ---------------

    const MAXIMUM_TEXT_LENGTH = 44;

    // ------ inherited state variables ------

    if (props.data) {
        var data = props.data;
        var onDataChange = props.onDataChange;
        var options = props.options || { draggable: false }
    }

    // const [ spellChecksInitial, setSpellChecks ] = props.spellChecks || "";
    const spellChecksAllArray = props.spellChecks || [null,null]
    
    const spellChecksInitial = ['2']

    // -------- local state variables --------
    const [ linkValue, setLinkValue ] = useState(props.initial);


    // ---------- HELPER FUNCTIONS ----------

    // Handle drag start
        const handleDragStart = (e) => {

            console.log('drag start', e)
            const dataStored = { id: e.target.id, value: e.target.innerHTML };

            // store spell checks data if this is a spell
            const position = e.target.id.slice(4,7)
            if (e.target.id[2] === "S") dataStored.checks = data[`mySpk${position}`]

            console.log('dataStored', dataStored)

            e.dataTransfer.setData('text/plain', JSON.stringify(dataStored)); // // Store data to transfer
            e.target.style.opacity = '0.5'; // Visual feedback during drag
        };

    // Handle drag end
        const handleDragEnd = (e) => {
            e.target.style.opacity = '1'; // Reset visual feedback
        };

    // Allow drop by preventing default behavior
        const handleDragOver = (e) => {
            e.preventDefault();
        };

    // Handle drop
        const handleDrop = (e) => {
            e.preventDefault();
            const receivedData = JSON.parse(e.dataTransfer.getData('text/plain'));
            const firstTargetID = receivedData.id
            const secondTargetID = e.target.id;
            const spellChecks = e.target.checks || null

            // get the values
            const firstBlock = document.getElementById(firstTargetID);
            const secondBlock = document.getElementById(secondTargetID);

            let firstValue = firstBlock.innerHTML;
            let secondValue = secondBlock.innerHTML;
            if (secondValue === "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" )
                secondValue = ""
            if (firstValue === "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" )
                firstValue = ""

            const verifyText = `${firstTargetID} [${firstValue}] dropped on ${secondTargetID} [${secondValue}]`

            console.log('DROP RECEIVED', e, data ); // Update state to indicate successful drop
            console.log(verifyText)

            // make the switch
            let tempHold;
            let newData = { ...data }

            // special handling for weapons
            if ( firstTargetID[2].toLowerCase() === "w" && secondTargetID[2].toLowerCase() === "w") {
                const position1 = firstTargetID[6]
                const position2 = secondTargetID[6]
                let element1 = document.getElementById(`myWth${position1}`)
                let element2 = document.getElementById(`myWth${position2}`)
                
                tempHold = element1.value
                newData[`myWth${position1}`] = element2.value
                newData[`myWth${position2}`] = tempHold

                element1 = document.getElementById(`myWdb${position1}`)
                element2 = document.getElementById(`myWdb${position2}`)
                tempHold = element1.value
                newData[`myWdb${position1}`] = element2.value
                newData[`myWdb${position2}`] = tempHold
                
                element1 = document.getElementById(`myWdmg${position1}`)
                element2 = document.getElementById(`myWdmg${position2}`)
                tempHold = element1.value
                newData[`myWdmg${position1}`] = element2.value
                newData[`myWdmg${position2}`] = tempHold

            }

            // special handling for armor
            if ( firstTargetID[2] === "A" && secondTargetID[2] === "A") {
                const position1 = firstTargetID[5]
                const position2 = secondTargetID[5]
                let element1 = document.getElementById(`myAb${position1}`)
                let element2 = document.getElementById(`myAb${position2}`)
                
                tempHold = element1.value
                newData[`myAb${position1}`] = element2.value
                newData[`myAb${position2}`] = tempHold
            }

            // special handling for potions
            if ( firstTargetID[2] === "P" && secondTargetID[2] === "P") {
                const position1 = firstTargetID[5]
                const position2 = secondTargetID[5]
                let element1 = document.getElementById(`myQpo${position1}`)
                let element2 = document.getElementById(`myQpo${position2}`)
                
                tempHold = element1.value
                newData[`myQpo${position1}`] = element2.value
                newData[`myQpo${position2}`] = tempHold
            }
            
            // special handling for spells
            if ( firstTargetID[2] === "S" && secondTargetID[2] === "S") {
                const position1 = firstTargetID.slice(4,7)
                const position2 = secondTargetID.slice(4,7)
                console.log(position1, position2)

                let checks1 = data[`mySpk${position1}`]
                let checks2 = data[`mySpk${position2}`]

                console.log(checks1, checks2)

                newData[`mySpk${position1}`] = checks2
                newData[`mySpk${position2}`] = checks1

                const index1 = 30 * (Number(position1[0]) - 1) + (Number(position1.slice(1,3) - 1 ))
                const index2 = 30 * (Number(position2[0]) - 1) + (Number(position2.slice(1,3) - 1 ))

                spellChecksAllArray[index1][1](checks2)
                spellChecksAllArray[index2][1](checks1)
                
            }


            newData[ firstTargetID.split('-')[0] ] = secondValue;
            newData[ secondTargetID.split('-')[0] ] = firstValue;

            console.log('Editable Link New Data', newData)

            onDataChange( newData )
            
        };


    // ------------- useEffect ---------------

    useEffect( () => {

        async function updateData () {
            // when the initial value changes, update the link value
            setLinkValue(props.initial)
        }

        updateData();

        // console.log('editable link props: ', props)

    }, [props.initial]); //useEffect

    const updateValue = (e) => {
        // let newValue = $(this).val();
        setLinkValue(e.target.value);
        
        const newData = { ...data };
        const id = e.target.id;
        newData[id] = sanitizeInput(e.target.value);

        console.log('newData: ', e.target.id )
        onDataChange(newData);
    }

    // ---------- handler functions ----------
    
    const handleClick = (e) => {
        console.log('---------  EditableLink.handleClick ------------')
        if (e.target.innerHTML !== "") {
            load_spell(e.target.innerHTML, props.spellUpdaters, e.target, props.globalState );
        }
    }

    // ---------- return html (jsx) ----------

    return (
        <>
         <div className='editable-div'>
            <button 
                id={props.id+'-but'} 
                className = 'stat-val-sm editable-link' 
                onClick = { handleClick }
                draggable = { options.draggable ? true : false }
                onDragStart={ options.draggable ? handleDragStart : null }
                onDragEnd={ options.draggable ? handleDragEnd : null }
                onDragOver= { options.draggable ? handleDragOver : null }
                onDrop={ options.draggable ? handleDrop : null }
            >
            {linkValue !== "" ? linkValue : "\u00A0\u00A0\u00A0\u00A0\u00A0"}
            </button>
            </div>
         <div className='editable-div'>
            <input id={props.id} className="editable-input stat-val-sm" type="text" 
            defaultValue={linkValue} maxLength={ MAXIMUM_TEXT_LENGTH} 
            onBlur={e => updateValue(e) }
            onChange={(event) => {
                
            }}/>
        </div>
        </>
    )

    };  // end of function

    export default EditableLink